import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { styles } from './styles';
import LocationData from '../../../features/locations/LocationData';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useViewLocationMutation } from '../../../api/locations';

const ViewLocations = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [locationDetails, setLocationDetails] = useState({});

    const { enqueueSnackbar } = useSnackbar();
    const [viewLocation, { isLoading }] = useViewLocationMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            bodyFormData.append('id', params.id);
            try {
                const response = await viewLocation(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setLocationDetails(response.locationInstance);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        }
        fetchData();
    }, [params.id, viewLocation, enqueueSnackbar]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Locations</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/locations')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <LocationData location={locationDetails} id={params.id} isLoading={isLoading} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewLocations;
